<template>
  <div class="d d_xm">
    <headers :goBack="goBack" />
    <template v-if="list">
      <form11 :list="list" />
      <div-footer :status="status" :isShow="true" :formId="39" :id="id" />
    </template>

    <template v-else>
      <van-empty description="暂无相关数据" />
    </template>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { getsubmitData } from "@/service/form";
import { format } from "@/common/js/utils";
import headers from "@/components/Header";
import form11 from "@/components/form/Form11";
import divFooter from "@/components/Footer";

export default {
  name: "detailForm40",
  components: {
    headers,
    divFooter,
    form11,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    const state = reactive({
      id: null,
      status: null,
      list: null,
    });

    onMounted(async () => {
      const { id, status } = route.query;
      state.status = status;
      state.id = id;
      const result = await getsubmitData({ dataId: id });
      const { code, data } = result;

      if (code == 10000 && data) {
        const newObj = {};
        for (const i of data.list) {
          newObj[i.fieldCode] = i.value;
        }
        state.list = newObj;
        state.status = data.status;
        state.id = data.id;
        console.log("result==", state.list);
      }
    });

    const goBack = () => {
      router.go(-1);
    };

    return {
      ...toRefs(state),
      format,
      goBack,
    };
  },
};
</script>
<style lang="less" scoped>
.d_xm {
  background-color: #f7f8fa;
  min-height: 100vh;
}
</style>
